/* eslint-disable */
window.CKEDITOR_BASEPATH = `${__webpack_public_path__}node_modules/ckeditor/`;

// Load your custom config.js file for CKEditor.
require(`!file-loader?context=${__dirname}&outputPath=node_modules/ckeditor/&name=[path][name].[ext]!./config.js`);

// Load your custom contents.css file in case you use iframe editor.
require(`!file-loader?context=${__dirname}&outputPath=node_modules/ckeditor/&name=[path][name].[ext]!./contents.css`);

// Load your custom styles.js file for CKEditor.
require(`!file-loader?context=${__dirname}&outputPath=node_modules/ckeditor/&name=[path][name].[ext]!./styles.js`);

/*//TODO: (bishal) loading all - issues with webpack when loading selective. Note: this creates a loader error - investigating but this won't break anything
// Load files from plugins.
require.context(
    '!file-loader?name=[path][name].[ext]!ckeditor/plugins/',
    true,
    /.*!/,
);*/

// Load files from plugins, excluding lang files.
// Limit to active plugins with
// Object.keys(CKEDITOR.plugins.registered).sort().toString().replace(/,/g, '|')
require.context(
    '!file-loader?name=[path][name].[ext]!ckeditor/plugins/',
    true,
    /^\.\/((a11yhelp|colorbutton|font|about|ajax|autocomplete|autogrow|basicstyles|blockquote|button|clipboard|contextmenu|dialog|dialogui|elementspath|enterkey|entities|fakeobjects|filebrowser|filetools|floatingspace|floatpanel|format|horizontalrule|htmlwriter|image|indent|indentlist|justify|lineutils|link|list|listblock|magicline|maximize|mentions|menu|menubutton|notification|notificationaggregator|panel|pastefromword|pastetext|popup|removeformat|resize|richcombo|scayt|showborders|sourcearea|specialchar|stylescombo|tab|table|tableselection|tabletools|textmatch|textwatcher|toolbar|undo|uploadimage|uploadwidget|widget|widgetselection|wsc|wysiwygarea|xml)(\/(?!lang\/)[^/]+)*)?[^/]*$/
);
// Load lang files from plugins.
// Limit to active plugins with
// Object.keys(CKEDITOR.plugins.registered).sort().toString().replace(/,/g, '|')
require.context(
    '!file-loader?name=[path][name].[ext]!ckeditor/plugins/',
    true,
    /^\.\/(a11yhelp|colorbutton|font|about|ajax|autocomplete|autogrow|basicstyles|blockquote|button|clipboard|contextmenu|dialog|dialogui|elementspath|enterkey|entities|fakeobjects|filebrowser|filetools|floatingspace|floatpanel|format|horizontalrule|htmlwriter|image|indent|indentlist|justify|lineutils|link|list|listblock|magicline|maximize|mentions|menu|menubutton|notification|notificationaggregator|panel|pastefromword|pastetext|popup|removeformat|resize|richcombo|scayt|showborders|sourcearea|specialchar|stylescombo|tab|table|tableselection|tabletools|textmatch|textwatcher|toolbar|undo|uploadimage|uploadwidget|widget|widgetselection|wsc|wysiwygarea|xml)\/(.*\/)*lang\/(en)\.js$/
);

// Load CKEditor lang files.
require.context(
    '!file-loader?name=[path][name].[ext]!ckeditor/lang',
    true,
    /(en)\.js/,
);

// Load skin.
require.context(
    '!file-loader?name=[path][name].[ext]!ckeditor/skins/moono-lisa',
    true,
    /.*/,
);

/* eslint-enable */
